<div class="aw-gd-container" *ngIf="selectedGroup != null">
  <div class="aw-gd-header-container">
    <div class="aw-gd-header-main">{{selectedGroup.name}}</div>
    <div class="aw-gd-header-sub">
      <object type="image/svg+xml" style="width: 16px; height: 16px; margin-right: 4px;"
        data="assets/images/group/ic_devices.svg">Your browser does not support SVGs</object>
      {{selectedGroup.deviceList.length}} Device<span *ngIf="selectedGroup.deviceList.length > 1">s</span>
    </div>
    <!-- <h4 class="aw-gd-header-sub">
      <object type="image/svg+xml" style="width: 13px; height: 13px; margin-right: 4px; padding-top: 1px;"
        data="assets/images/group/ic_viewers.svg">Your browser does not support SVGs</object>
      12 Viewers
    </h4> -->
    <div class="aw-gd-actions-container flex-right" *ngIf="selectedGroup.id != null" (document:click)="onDropdownEvent($event, action, false)" #action>
      <div class="aw-gd-actions" style="padding: 4px 0px; cursor: pointer;">
        <object type="image/svg+xml" style="width: 16px; height: 16px;"
          data="assets/images/group/ic_actions.svg">Your browser does not support SVGs</object>
      </div>

      <ul class="dropdown">
        <li class="list-item" (click)="onAddDevice()">
          Add Devices
        </li>
        <li class="list-item" (click)="onManageMember()">
          Manage Members
        </li>
        <!-- <li class="list-item">
          Edit Name
        </li> -->
        <li class="list-item" style="color: #868D94" (click)="onDeleteGroup()">
          Delete Group
        </li>
      </ul>
    </div>
  </div>

  <div class="aw-gd-ctrl-bar">
    <div class="all-check-container">
      <!-- Select All -->
      <input type="checkbox" class="aw-checkbox" style="margin-right: 8px;"
        [disabled]="selectedGroup.deviceList.length === 0"
        [checked]="isAllChecked"
        (change)="selectAllCheck(isAllChecked)"/>
      <span *ngIf="selectedDeviceList.length === 0">Select All</span>
      <span *ngIf="selectedDeviceList.length > 0">{{selectedDeviceList.length}} Selected</span>
      <!-- /.Select All -->
    </div>
    <div class="aw-btn-group flex-right" *ngIf="selectedDeviceList.length > 0">
      <!-- Remove Button -->
      <div class="aw-gd-ctrl-btn" style="margin-right: 8px;" *ngIf="selectedGroup.id != null" (click)="onRemoveFromGroup()">
        <object type="image/svg+xml" style="width: 16px; height: 16px; margin-right: 8px;"
          data="assets/images/group/ic_remove.svg">Your browser does not support SVGs</object>
        Remove
      </div>
      <!-- /.Remove Button -->

      <!-- Move To -->
      <div class="move-container" (document:click)="onDropdownEvent($event, move, true)" #move>
        <div class="aw-gd-ctrl-btn" >
          <object type="image/svg+xml" style="width: 16px; height: 16px; margin-right: 8px;"
            data="assets/images/group/ic_move.svg">Your browser does not support SVGs</object>
          Move To
        </div>
         <ul class="dropdown" *ngIf="groupedDeviceList.length === 1" style="top: 23px;">
          <li class="list-item" style="pointer-events: none; color: #ACB4BB;">
            No group
          </li>
        </ul>
        <ul class="dropdown" *ngIf="groupedDeviceList.length > 1" style="top: 23px;">
          <li class="list-item" *ngFor="let otherGroupedDevice of otherGroupedDeviceList | objArraySort:'name'" (click)="onAssignToGroup(otherGroupedDevice.id)">
            {{otherGroupedDevice.name | namize}}
          </li>
        </ul>
      </div>
      <!-- /.Move To -->

    </div>
  </div>

  <!-- Device List -->
  <div class="aw-sm-list-container">
    <!-- Yes Device -->
    <ul class="aw-sm-list" *ngIf="selectedGroup.deviceList.length > 0" style="max-height: 415px;">
      <li class="aw-sm-list-item" *ngFor="let deviceWithCheck of deviceWithCheckList">
        <input type="checkbox" class="aw-checkbox" style="margin-right: 20px; margin-top: 3px;"
          [checked]="deviceWithCheck.checked"
          (change)="selectDevice(deviceWithCheck)"/>
        {{deviceWithCheck.deviceName}}
        <span class="aw-sm-list-item-sub flex-right">{{deviceWithCheck.email}}</span>
      </li>
    </ul>
    <!-- /.Yes Device -->

    <!-- No Device -->
    <div class="no-device" *ngIf="selectedGroup.deviceList.length === 0">
      <div class="no-device-header" style="margin-bottom: 4px;">There are currently no devices in</div>
      <div class="no-device-header" style="margin-bottom: 32px;">{{selectedGroup.name}}</div>
      <div class="add-device-btn" style="margin: 0 auto" *ngIf="selectedGroup.id != null" (click)="onAddDevice()">
        <object type="image/svg+xml" style="width: 24px; height: 24px; margin-right: 8px;"
          data="assets/images/group/ic_add.svg">Your browser does not support SVGs</object>
        Add Devices
      </div>
    </div>
    <!-- /.No Device -->
  </div>
  <!-- ./Device List -->
</div>
